import React from "react";
import { useSelector } from "react-redux";
import loadable from "@loadable/component";
import pMinDelay from "p-min-delay";

const PieChart = loadable(() => pMinDelay(import("../../Omah/Home/Chart/PieChart"), 500));
// const ChartBar = loadable(() => pMinDelay(import("../../Omah/Home/Chart/ChartBar"), 500));

function PropertyOverView() {
    const { propertySummary } = useSelector((state) => state.report);
    const total = propertySummary?.totalProperties || 0;
    const featured = propertySummary?.featuredProperties || 0;
    const nonFeatured = total - featured > 0 ? total - featured : 0;
    const verified = propertySummary?.verifiedProperties || 0;
    const bankVerified = propertySummary?.bankVerifiedProperties || 0;

    // Calculate percentages
    const featuredPercent = total > 0 ? Math.round((featured / total) * 100) : 0;
    const nonFeaturedPercent = total > 0 ? 100 - featuredPercent : 0;
    const verifiedPercent = total > 0 ? Math.round((verified / total) * 100) : 0;
    const bankVerifiedPercent = total > 0 ? Math.round((bankVerified / total) * 100) : 0;

    return (
        <div className="col-xl-12 col-xxl-12">
            <div className="row">
                {/* <div className="col-xl-8 col-xxl-12">
                    ...existing code...
                </div> */}
                <div className="col-xl-12 col-xxl-12">
                    <div className="row">
                        <div className="col-xl-6 col-xxl-6 col-md-6">
                            <div className="card">
                                <div className="card-body">
                                    <div id="monocromeChart" />
                                    {/* Pass calculated percentages to PieChart */}
                                    <PieChart series={[featuredPercent, nonFeaturedPercent]} />
                                    <div className="d-flex flex-wrap mt-3">
                                        <span className="text-black font-w600 me-5 mb-2">
                                        <svg
                                            className="me-2"
                                            width={20}
                                            height={20}
                                            viewBox="0 0 20 20"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <rect
                                            width={20}
                                            height={20}
                                            rx={8}
                                            fill="#FFB067"
                                            />
                                        </svg>
                                        Featured Properties({featured})
                                        </span>
                                        <span className="text-black font-w600 mb-2">
                                        <svg
                                            className="me-2"
                                            width={20}
                                            height={20}
                                            viewBox="0 0 20 20"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <rect
                                            width={20}
                                            height={20}
                                            rx={8}
                                            fill="#B655E4"
                                            />
                                        </svg>
                                        Non Featured Properties({nonFeatured})
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-6 col-xxl-6 col-md-6">
                            <div className="card">
                                <div className="card-body">
                                    <p className="mb-2 d-flex  fs-16 text-black font-w500">
                                        Properties Listed
                                        <span className="pull-right ms-auto text-dark fs-14">
                                        {total}
                                        </span>
                                    </p>
                                    <div className="progress mb-4" style={{ height: 10 }}>
                                        <div
                                        className="progress-bar bg-primary progress-animated"
                                        style={{ width: "100%", height: 10 }}
                                        role="progressbar"
                                        >
                                        <span className="sr-only">100% Complete</span>
                                        </div>
                                    </div>
                                    <p className="mb-2 d-flex  fs-16 text-black font-w500">
                                        Properties Featured
                                        <span className="pull-right ms-auto text-dark fs-14">
                                        {featured}
                                        </span>
                                    </p>
                                    <div className="progress mb-3" style={{ height: 10 }}>
                                        <div
                                        className="progress-bar bg-primary progress-animated"
                                        style={{ width: `${featuredPercent}%`, height: 10 }}
                                        role="progressbar"
                                        >
                                        <span className="sr-only">{featuredPercent}% Complete</span>
                                        </div>
                                    </div>
                                    <p className="mb-2 d-flex  fs-16 text-black font-w500">
                                        Properties Verified
                                        <span className="pull-right ms-auto text-dark fs-14">
                                        {verified}
                                        </span>
                                    </p>
                                    <div className="progress mb-3" style={{ height: 10 }}>
                                        <div
                                        className="progress-bar bg-primary progress-animated"
                                        style={{ width: `${verifiedPercent}%`, height: 10 }}
                                        role="progressbar"
                                        >
                                        <span className="sr-only">{verifiedPercent}% Complete</span>
                                        </div>
                                    </div>
                                    <p className="mb-2 d-flex  fs-16 text-black font-w500">
                                        Bank Verified Properties 
                                        <span className="pull-right ms-auto text-dark fs-14">
                                        {bankVerified}
                                        </span>
                                    </p>
                                    <div className="progress mb-3" style={{ height: 10 }}>
                                        <div
                                        className="progress-bar bg-primary progress-animated"
                                        style={{ width: `${bankVerifiedPercent}%`, height: 10 }}
                                        role="progressbar"
                                        >
                                        <span className="sr-only">{bankVerifiedPercent}% Complete</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default PropertyOverView;